import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AuthService from "../auth/AuthService";
import Tabs from "../common/PublicTabs";
import { ThingsProvider } from "../PublicLayout/thingsContext";
import { SnackbarProvider } from "notistack";

import config from "../../config";

const AUTH = new AuthService();

const drawerWidth = config.app === "Studio" ? 16 * 22 : 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f9e7b3 0%, #f4d03f 100%)",
  },
  appBar: {
    background: "#fdfffc",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    minHeight: "70px",
    padding: theme.spacing(0, 2),
    background: "#E9F5E9",
    color: "#ffffff",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    // backgroundColor: "rgba(255,255,255,0.1)",
    // backgroundColor: "#2d4f46",
    backgroundColor: "#39A057",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    "&:hover": {
      // backgroundColor: "rgba(255,255,255,0.2)",
      backgroundColor: "#2d4f46",
      transform: "translateY(-1px)",
    },
  },
  hide: {
    display: "none",
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#ffffff",
    borderRight: "1px solid #e0e6ed",
    boxShadow: "4px 0 15px rgba(0,0,0,0.08)",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    minHeight: "70px",
    justifyContent: "flex-end",
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #e0e6ed",
  },
  drawerCloseButton: {
    color: "#64748b",
    backgroundColor: "rgba(100,116,139,0.1)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(100,116,139,0.2)",
      transform: "translateX(2px)",
    },
  },
  content: {
    flexGrow: 1,
    padding: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    backgroundColor: "#f9e7b3",
    minHeight: "calc(100vh - 70px)",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  title: {
    // color: "#23242b",
    color: "#39A057",
    flexGrow: 1,
    fontWeight: 600,
    letterSpacing: "0.5px",
    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  schoolName: {
    color: "#23242b",
    fontWeight: 400,
    opacity: 0.9,
  },
  divider: {
    backgroundColor: "#e0e6ed",
    height: "1px",
  },
  contentGrid: {
    backgroundColor: "transparent",
    width: "100%",
    margin: 0,
  },
  drawerContent: {
    height: "100%",
    backgroundColor: "#ffffff",
   
  },
}));

// #23242b
export default function PersistentDrawerLeft({ children }) {
  const classes = useStyles();
  const [openLeft, setOpenLeft] = useState(false);

  const [things, setThings] = useState([]);

  const handleLeftDrawerOpen = () => {
    setOpenLeft(true);
    localStorage.setItem("drawer_open_left", 1);
  };

  const handleLeftDrawerClose = () => {
    setOpenLeft(false);
    localStorage.setItem("drawer_open_left", 0);
    console.log(localStorage.getItem("drawer_open_left", 0));
  };

  return (
    <SnackbarProvider maxSnack={3}>
      <div className={classes.root}>
        <ThingsProvider value={[things, setThings]}>
          <CssBaseline />
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: openLeft,
            })}
            elevation={0}
          >
            <Toolbar className={classes.toolbar}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleLeftDrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, openLeft && classes.hide)}
              >
                <MenuIcon />
              </IconButton>

              <Typography className={classes.title} variant="h6" noWrap>
                Jobifyy {config.app}
                {AUTH.loggedIn() && (
                  <span className={classes.schoolName}>
                    {" "}
                    ({AUTH.getProfile().school_name})
                  </span>
                )}
              </Typography>
            </Toolbar>
          </AppBar>

          <Drawer
            variant="persistent"
            anchor="left"
            open={openLeft}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton
                onClick={handleLeftDrawerClose}
                className={classes.drawerCloseButton}
              >
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.drawerContent}>
              <Tabs />
            </div>
          </Drawer>

          <main
            className={clsx(classes.content, {
              [classes.contentShift]: openLeft,
            })}
          >
            <div className={classes.drawerHeader} />
            <Grid container spacing={3} className={classes.contentGrid}>
              {children}
            </Grid>
          </main>
        </ThingsProvider>
      </div>
    </SnackbarProvider>
  );
}